import { DwellTimeHelper } from '@atlassiansox/analytics-web-client';

const getDwellTimeHelper = (sendMethod: any, eventData: any) => {
	return new DwellTimeHelper(sendMethod, eventData);
};

export default getDwellTimeHelper;
